/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import {
	queryOptions,
	useQuery,
} from '@tanstack/react-query';

// Types
import { TParamsGetApi } from '@global-types/index';

// Lib
import { apiClient } from '@lib/api-client';

// Constants
import { queryKeys } from '@config/constants/query-keys';
import { TApiResponseGetMeasurabilities } from '@features/resources/measurabilities/types';
import { QueryConfig } from '@lib/react-query';

/* -------------------------------------------------------------------------- */
/*                                     Api                                    */
/* -------------------------------------------------------------------------- */
export const getMeasurabilities = (
	params: Partial<TParamsGetApi>
): Promise<TApiResponseGetMeasurabilities> => {
	return apiClient.get('/measurabilities', {
		params,
	});
};

/* -------------------------------------------------------------------------- */
/*                                    Type                                    */
/* -------------------------------------------------------------------------- */
type TUseGetMeasurabilitiesOptions = {
	params: Partial<TParamsGetApi>;
	queryConfig?: QueryConfig<typeof getMeasurabilities>;
};

/* -------------------------------------------------------------------------- */
/*                                    Helper                                  */
/* -------------------------------------------------------------------------- */
export const getPostsQueryOptions = (
	params: Partial<TParamsGetApi> = {}
) => {
	return queryOptions({
		queryKey: params
			? [
					queryKeys.app.measurabilityProjects.list.key,
					{ params },
				]
			: [queryKeys.app.measurabilityProjects.list.key],
		queryFn: () => getMeasurabilities(params),
	});
};

/* -------------------------------------------------------------------------- */
/*                                     Hook                                   */
/* -------------------------------------------------------------------------- */
export const useGetMeasurabilities = ({
	params,
	queryConfig,
}: TUseGetMeasurabilitiesOptions) => {
	return useQuery({
		...getPostsQueryOptions(params),
		...queryConfig,
	});
};
